const API_BASE_URL = process.env.REACT_APP_API_URL || '/api' || 'http://localhost:8080/api' || 'http://backend:8080/api' ; // proxy ou prod

export default API_BASE_URL;
